import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reset-basket-modal',
  templateUrl: './reset-basket-modal.component.html',
  styleUrls: ['./reset-basket-modal.component.css']
})
export class ResetBasketModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
